import ExamForm from "../../components/ExamForm/ExamForm";
const EditExam = () => {
    return (
        <div style={{ marginTop: '3%' }}>
            <ExamForm type="Edit" />
        </div>
    )
}
export default EditExam;